import React, { useEffect } from 'react';
import './QualityAssurance.css'; // Optional: custom styles for the component
import AOS from 'aos';
import 'aos/dist/aos.css';

const QualityAssurance = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <header
        className="quality-assurance-hero text-center py-5 text-white"
        style={{
          background: 'linear-gradient(135deg, #2a3d66, rgb(6, 41, 52))',
        }}
        data-aos="fade-down"
      >
        <div className="container">
          <h1 className="fw-bold mb-4 display-3 text-shadow">Quality Assurance at Ag Pipe Fitting Technology</h1>
          <p className="lead mb-4 fs-4">
            Delivering precision, durability, and reliability in every product.
          </p>
        </div>
      </header>

      {/* Quality Assurance Section */}
      <section className="quality-assurance py-5" style={{ backgroundColor: '#f9f9f9' }}>
        <div className="container">
          <h2 className="text-center text-primary fw-bold mb-5" data-aos="fade-up">
            Our Commitment to Quality Assurance
          </h2>
          <div className="row g-4">
            <div className="col-lg-12" data-aos="fade-in">
              <div className="card shadow-sm border-0 rounded-4 p-5">
                <h4 className="card-title text-primary fw-bold mb-4">
                  Industry-Leading Quality Assurance
                </h4>
                <p className="fs-5 text-muted">
                  At Ag Pipe Fitting Technology, quality is at the heart of everything we do. We adhere to the highest
                  standards of quality control throughout our manufacturing process. From the moment raw materials are
                  sourced to the delivery of the final product, we ensure every step meets or exceeds industry standards.
                </p>
                <p className="fs-5 text-muted">
                  Our skilled team conducts rigorous testing and inspections at each stage to guarantee durability, 
                  performance, and reliability. This ensures that the products we deliver are not only reliable but
                  also meet the specific requirements of our clients.
                </p>
                <p className="fs-5 text-muted">
                  We understand the importance of delivering superior products to our clients, which is why we invest in
                  cutting-edge technology, continuous employee training, and ongoing quality certification programs. Our
                  commitment to excellence is evident in every aspect of our operation.
                </p>
                <p className="fs-5 text-muted">
                  Our continuous focus on quality enables us to stay ahead of industry trends, ensuring that we offer
                  innovative and superior solutions for all your pipe fitting needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default QualityAssurance;
